import { Injectable } from '@angular/core';
import { FormService } from '../form/form.service';

@Injectable()

export class PushableService {

  constructor() { }
  public formService: FormService;

  beforeOnSubmit(result,cb) {
    var cardData = this.formService.cardData.data;
    Object.keys(result).forEach(key => {
      if (result[key] != "" && this.formService.form.controls[key]['question_component'] && this.formService.form.controls[key]['question_component'].question && this.formService.form.controls[key]['question_component'].question.controlType && this.formService.form.controls[key]['question_component'].question.controlType == 'pushable') {
        var action_source = this.formService.form.controls[key]['question_component'].question.pushable_master;
        var resultData = JSON.parse(result[key]);
        resultData.forEach(data => {
          Object.keys(data).forEach(keys => {
            if (data[keys] == "")
              data[keys] = cardData[keys];
          })
          // in case of self note
          if (action_source.frontend_resource == 'self_note')
            data['userId'] = this.formService.authenticationService.getCurrentUser().user_id;
        });
        setTimeout(() => {
          this.formService.baseService.action(resultData, action_source.action, action_source.application_id, action_source.resource).subscribe(res => {
            if (res.errCode == 0) {
            } else {
              this.formService.alerts.error(res.message)
            }
            cb(true)
          })
        })
      }
    })
  }
}
